<template>
  <FindBrokerView />
</template>
<script>
import FindBrokerView from "@/features/find-broker/FindBrokerView.vue";
export default {
  components: {
    FindBrokerView,
  },
};
</script>
